const ALLOWED_CREATIVE_DIMENSIONS = {
  WIDTH: 1280,
  HEIGHT: 720,
};

export interface ExtendedFile extends File {
  objectURL: string;
}
export async function areCreativeDimensionsValid(file: ExtendedFile[]): Promise<boolean> {
  if (file.length === 0) {
    return false;
  }

  return new Promise((resolve) => {
    const image = new Image();
    image.src = file[0].objectURL;

    image.onload = () => {
      const { width, height } = image;
      const isValid = width === ALLOWED_CREATIVE_DIMENSIONS.WIDTH && height === ALLOWED_CREATIVE_DIMENSIONS.HEIGHT;
      resolve(isValid);
    };

    image.onerror = () => {
      resolve(false);
    };
  });
}
